import { TopolRawBlock } from "@/schemas/template/blocks/rawBlockSchema";
import { i18n } from "../../init/i18n-setup";
import calcWidth from "./helpers";
import { v4 as uuidv4 } from "uuid";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number }
  ): TopolRawBlock {
    return {
      uid: uuidv4(),
      tagName: "mj-raw",
      content: `<tr>\n\t<td>\n\t\t<p>${i18n.global.t(
        "blocks.raw_content"
      )}</p>\n\t</td>\n</tr>`,
      attributes: {
        containerWidth: calcWidth(
          state.mjml.children[0].attributes["containerWidth"],
          state.mjml.children[0].children[props.sectionIndex].children[
            props.columnIndex
          ].attributes["width"]
        ),
      },
    };
  },
};
